import { render, staticRenderFns } from "./AccountBlockList.vue?vue&type=template&id=91ce678c&scoped=true"
import script from "./AccountBlockList.vue?vue&type=script&lang=js"
export * from "./AccountBlockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ce678c",
  null
  
)

export default component.exports